import axios from "axios";
import Config from "@/config"

export default class ReportService {
  getList(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/installation/list",
        options
      )
      .then(res => res.data);
  }
  get(accesstoken, reportId) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/installation/" + reportId,
        options
      )
      .then(res => res.data);
  }
  download(accesstoken, reportId, lang) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
      responseType: 'blob'
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/installation/" + reportId + "?type=pdf&language="+lang,
        options
      )
      .then(res => res);
  }
  models(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/installation/models",
        options
      )
      .then(res => res.data.body);
  }
  create(accesstoken, report) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/factory/installation/report?complete=false", report,
        options
      )
      .then(res => res.data);
  }
  update(accesstoken, reportId, report, isComplete) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .put(
        Config.proxy + Config.url("appliance") + "/factory/installation/report/" + reportId + "?complete=" + isComplete, report,
        options
      )
      .then(res => res.data);
  }
  uploadSignature(accesstoken, reportId, base64Image) {

    // Split into two parts
    const parts = base64Image.split(';base64,');
    // Hold the content type
    const imageType = parts[0].split(':')[1];
    // Decode Base64 string
    const decodedData = window.atob(parts[1]);
    // Create UNIT8ARRAY of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);
    // Insert all character code into uInt8Array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // Return BLOB image after conversion
    let blob = new Blob([uInt8Array], { type: imageType });
    let formData = new FormData();
    formData.append("file", blob);

    const options = {
      headers: { ...Config.headers(accesstoken), ...{'Content-Type':`multipart/form-data`} }
    };
    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/factory/installation/image?installationReportId=" + reportId + "&signature=true", formData,
        options
      )
      .then(res => res.data);
  }
  uploadImage(accesstoken, reportId, file) {
    let formData = new FormData();
    formData.append("file", file);
    const options = {
      headers: { ...Config.headers(accesstoken), ...{ 'Content-Type': `multipart/form-data` } }
    };
    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/factory/installation/image?installationReportId=" + reportId + "&signature=false", formData,
        options
      )
      .then(res => res.data);
  }
  getImage(accesstoken, image) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
      responseType: 'blob'
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/installation/image?filePath=" + image,
        options
      )
      .then(res => res);
  }
}
